// Persistent theme toggle shown at the bottom of every screen.
// Applies the theme by setting a data-theme attribute on <html>,
// which CSS variables in globals.css respond to.

import React from 'react';
import type { Theme } from '../types';
import shared from '../styles/shared.module.css';

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

export default function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  return (
    <div className={shared.themeToggle}>
      <button
        className={`${shared.themeBtn} ${theme === 'scholar' ? shared.themeBtnActive : ''}`}
        onClick={() => theme !== 'scholar' && onToggle()}
        aria-pressed={theme === 'scholar'}
      >
        📜 Scholar
      </button>
      <button
        className={`${shared.themeBtn} ${theme === 'alien' ? shared.themeBtnActive : ''}`}
        onClick={() => theme !== 'alien' && onToggle()}
        aria-pressed={theme === 'alien'}
      >
        👾 Alien
      </button>
    </div>
  );
}